import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import PsContext from "../../context";
import { Col, Row } from "react-bootstrap";
import { momentDate, upperCase } from "../../utils";

const Footer = (props) => {
  const context = useContext(PsContext);
  const location = useLocation();

  return (
    <>
      <div
        className="footer-bg w-100 px-1"
        style={{
          borderTopLeftRadius: "25px",
          borderTopRightRadius: "25px",
          position: "fixed",
          bottom: "0",
          fontSize: "14px",
          left: 0,
        }}
      >
        <Row className="py-2">
          <Col>
            <div align="center" className="text-white">
              {momentDate(new Date(), "YYYY")} &copy;
              <span className="fw-bolder">
                {" "}
                {upperCase(context.settingValue("universityheader_name",''))}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default Footer;
